export enum U2000_VerifyEmailNavigationStepsEnum {
    verifyCode,
    completed,
}
